<template>
  <AppLink
    to="/"
    class="logo"
  >
    <img
      :src="color === 'black' ? '/travelbags.svg' : '/travelbags-w.svg'"
      :alt="$t('Go to homepage')"
      class="logo__image"
      width="160"
      height="32"
    >
  </AppLink>
</template>

<script setup lang="ts">
defineProps({
  color: {
    type: String,
    default: 'white',
  },

})
</script>

<style>
@import url("~layers/app/components/App/Logo.css");
</style>
